import { Outlet, Route, Routes, useParams } from "react-router";

import { Box, useMediaQuery, useTheme } from "@mui/material";
import PropTypes from "prop-types";

function MasterDetail({ master, detail, identifier, emptyAccessKey, empty }) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("md"));
  const params = useParams();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "auto", md: "316px auto", xl: "366px auto" },
              height: "100dvh",
            }}
          >
            {(!mobileView || !params["*"]) && (
              <Box sx={{ position: "relative", pl: 2, pr: mobileView ? 2 : 0 }}>{master}</Box>
            )}
            <Outlet />
          </Box>
        }
      >
        {!mobileView && <Route index element={<Box sx={{ overflow: "auto", pt: 10, pb: 2 }}>{empty}</Box>} />}
        {emptyAccessKey && (
          <Route path={emptyAccessKey} element={<Box sx={{ overflow: "auto", pt: 10, pb: 2 }}>{empty}</Box>} />
        )}
        <Route path={`:${identifier}`} element={<Box sx={{ overflow: "auto", pt: 10, pb: 2 }}>{detail}</Box>} />
      </Route>
    </Routes>
  );
}

MasterDetail.propTypes = {
  master: PropTypes.node,
  detail: PropTypes.node,
  empty: PropTypes.node,
  emptyAccessKey: PropTypes.string,
  identifier: PropTypes.string,
};

export default MasterDetail;
